import { IconButton, InputAdornment } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import CrossIcon from 'assets/img/icons/cross.svg?react';
import { LwFormInput } from 'redesign';

type SearchInputProps = {
  value?: string;
  onChange: (value: string | undefined) => void;
  placeholder?: string;
  label?: string;
  enableKeyboardShortcut?: boolean;
};

type SearchForm = {
  search: string | null;
};

export const SearchInput = ({
  value,
  onChange,
  placeholder = 'Zoeken',
  label = 'Zoeken',
  enableKeyboardShortcut = false,
}: SearchInputProps) => {
  const form = useForm<SearchForm>({
    defaultValues: {
      search: value ?? null,
    },
  });

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!enableKeyboardShortcut) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [enableKeyboardShortcut]);

  return (
    <LwFormInput
      name="search"
      control={form.control}
      label={label}
      placeholder={placeholder}
      onChange={(e) => {
        onChange(e.target.value ?? undefined);
      }}
      InputProps={{
        inputRef: inputRef,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="veld leegmaken"
              onClick={() => {
                form.setValue('search', null);
                onChange(undefined);
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              <CrossIcon width={20} height={20} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
